import * as React from "react";

import Input from "@common/designSystem/Input";
import LabeledControl from "@editor/components/common/designSystem/LabeledControl";

import { useProfileForm } from "@/editor/hooks/useProfileForm";
import Button from "@replo/design-system/components/button/Button";

export default function SecurityBoard() {
  const {
    registerPassword,
    handlePasswordSubmit,
    passwordErrors,
    isUpdatingPassword,
    canUpdatePassword,
  } = useProfileForm({ userGetQueryArgs: {} });

  return (
    <div className="flex w-64 flex-col">
      <h3 className="header-h3 text-default mb-2">Update Password</h3>
      <form onSubmit={(e) => void handlePasswordSubmit(e)}>
        <LabeledControl
          label="Current Password"
          error={passwordErrors?.password?.message}
        >
          <Input
            // TODO (Chance 2023-11-10): This field should be marked as
            // required in its markup.
            validityState={
              passwordErrors?.password?.message ? "invalid" : undefined
            }
            placeholder="••••••••••••"
            type="password"
            autoComplete="current-password"
            size="base"
            {...registerPassword("password")}
          />
        </LabeledControl>
        <LabeledControl
          label="New Password"
          className="mt-2"
          error={passwordErrors?.newPassword?.message}
        >
          <Input
            // TODO (Chance 2023-11-10): This field should be marked as
            // required in its markup.
            validityState={
              passwordErrors?.newPassword?.message ? "invalid" : undefined
            }
            placeholder="••••••••••••"
            type="password"
            autoComplete="new-password"
            size="base"
            {...registerPassword("newPassword")}
          />
        </LabeledControl>
        <div className="mt-4">
          <Button
            variant="primary"
            type="submit"
            size="base"
            disabled={isUpdatingPassword || !canUpdatePassword}
            isLoading={isUpdatingPassword}
          >
            Update Password
          </Button>
        </div>
      </form>
    </div>
  );
}
